<template lang="pug">
  .width-100.m-top-2
    ephemeride-banner(:loading='loading')
    section.section.column.width-100(v-if='folders.totalCount || folders.loading')
      h2.title-medium.m-bottom-1 {{ $t("feed.ephemeride.sections.folders") }}
      .loader.folder.relative.row.middle.center.width-100(v-if='folders.loading && folders.page === 0')
        sk-folder-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        kimple-folder-feed.m-bottom-2(
          v-for='folder in folders.data'
          :key='folder.id' noMargin
          :folder='folder'
          @copyFolder='copyFolder'
          origin='Search results'
        )
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='folders.page + 1 < folders.totalPages'
        @click='loadMoreContent("folders")'
      ) {{ $t("feed.ephemeride.seeMore") }}
    section.section.column.width-100(v-if='programs.totalCount || programs.loading')
      h2.title-medium.m-bottom-1 {{ $t("feed.ephemeride.sections.programs") }}
      .loader.program.relative.row.middle.center.width-100(v-if='programs.loading && programs.page === 0')
        sk-educational-program-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        educational-program-card.m-bottom-2(
          v-for='program in programs.data'
          :key='program.id' noMargin
          :program='program'
        )
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='programs.page + 1 < programs.totalPages'
        @click='loadMoreContent("programs")'
      ) {{ $t("feed.ephemeride.seeMore") }}
    section.section.column.width-100(v-if='resources.totalCount || resources.loading')
      h2.title-medium.m-bottom-1 {{ $t("feed.ephemeride.sections.resources") }}
      .loader.resource.relative.row.middle.center.width-100(v-if='resources.loading && resources.page === 0')
        sk-resource-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        resource-card.m-bottom-2(
          v-for='resource in resources.data'
          :key='resource.id'
          :resource='resource' noMargin
          :bookmarked='resource.isInAnyFolder'
        )
      button.m-left-auto.m-right-auto.text-normal.bold.blue.m-top-2(
        v-if='resources.page + 1 < resources.totalPages'
        @click='loadMoreContent("resources")'
      ) {{ $t("feed.ephemeride.seeMore") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import amplitude from 'amplitude-js'
import Loader from '../Loader'
import EphemerideBanner from './Banners/EphemerideBanner'
import ResourceCard from '../ResourceCard'
import EducationalProgramCard from '@/components/EducationalProgramCard'
import KimpleFolderFeed from '@/components/KimpleFolderFeed'
import SkResourceCard from '@/components/SkResourceCard'
import SkEducationalProgramCard from '@/components/SkEducationalProgramCard'
import SkFolderCard from '@/components/SkFolderCard'

export default {
  components: {
    Loader,
    EphemerideBanner,
    ResourceCard,
    EducationalProgramCard,
    KimpleFolderFeed,
    SkResourceCard,
    SkEducationalProgramCard,
    SkFolderCard
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {
    async locale(newLocale) {
      if (this.ephemerideInfo.availableLanguages.includes(newLocale)) {
        this.loading = true
        await this.hydrateEphemerideData({
          id: this.$route.query.ephemerideId,
          locale: newLocale
        })
        this.loading = false
      }
    }
  },
  async created() {
    this.loading = true
    await this.hydrateEphemerideData({
      id: this.$route.query.ephemerideId,
      locale: this.$route.query.ephemerideLocale
    })
    amplitude.getInstance().logEvent('Kimple folder', {
      id: this.ephemerideInfo.id,
      name: this.ephemerideInfo.title,
      origin: 'Search results ephemeride'
    })
    this.loading = false
    this.loadContent('resources')
    this.loadContent('programs')
    this.loadContent('folders')
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale,
      ephemerideInfo: state => state.newFeed.searchResults.ephemeride.data,
      resources: state => state.newFeed.searchResults.ephemeride.resources,
      programs: state => state.newFeed.searchResults.ephemeride.programs,
      folders: state => state.newFeed.searchResults.ephemeride.folders
    })
  },
  methods: {
    ...mapActions([
      'hydrateEphemerideData',
      'hydrateEphemerideContent'
    ]),
    loadContent(content) {
      this.hydrateEphemerideContent({
        content,
        firstLoading: true,
        id: this.$route.query.ephemerideId,
        pageNumber: 0,
        pageSize: 4
      })
    },
    loadMoreContent(content) {
      this.hydrateEphemerideContent({
        content,
        id: this.$route.query.ephemerideId,
        pageNumber: this[content].page + 1,
        pageSize: 4
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.section{
  padding: 25px 0;
}
.loader{
  height: 500px;
}
.loader{
  gap: 20px;
  &.resource{
    height: 260px;
  }
  &.folder{
    height: 220px;
  }
  &.program{
    height: 370px;
  }
  &.topic{
    height: 327px;
  }
}
</style>
